var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPalmLeafsRightSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 68,
    viewBox: "0 0 63 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51.8552 39.6345L57.7446 44.0974L55.4697 51.1966L48.8938 50.938L54.2283 55.1518L51.1775 64.7356C23.8179 40.5346 62.9147 27.9719 62.9147 27.9719L59.4494 38.9754L51.8552 39.6345Z",
    fill: "#FFBA94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4914 -6.02087C46.9718 -7.24053 52.7051 -1.45265 54.8373 3.22115L48.5674 3.55507L46.0987 -0.686753L45.579 3.72402L42.5906 3.89298L38.2846 -3.37724L37.4437 4.15484L35.7342 4.21893L33.4655 0.329054L32.9891 4.30387L24.5419 4.8003C24.5919 4.88828 26.061 -4.71321 36.4914 -6.02087Z",
    fill: "#FFBA94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.7732 18.702L51.0726 28.4585C49.0885 30.0406 46.9529 31.5731 44.7671 33.0554L38.1789 27.1806L38.2151 36.6927C31.4655 39.6229 24.4758 40.6827 18.4287 37.081C18.4287 37.081 20.8131 28.7667 26.9872 21.1854L31.7257 23.784L29.7914 18.0797C32.0323 15.9393 34.5755 13.9992 37.5207 12.4611L40.8572 20.2809L44.0636 10.1394C50.2459 8.78162 57.6293 9.33828 66.5596 13.072C66.5596 13.072 62.0185 18.6183 55.3487 24.685L49.7732 18.702Z",
    fill: "#FFBA94"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPalmLeafsRightSmall);
export default __webpack_public_path__ + "static/media/palmLeafsRightSmall.dbb1a9dac3195956595375c947e9e1aa.svg";
export { ForwardRef as ReactComponent };